import React from "react";
import {TypeAnimation} from "react-type-animation"
import { motion } from "framer-motion";
import useTranslation from "../Constant";
import { resume } from "../Constant/common";

const Home = ({darkMode}) => {
  const Constant = useTranslation()

  return (
    <>
      <div
        style={
          darkMode
            ? { backgroundImage: `url('${Constant.cloud}')`, backgroundSize: "cover" }
            : { backgroundImage: `url('${Constant.cloudDark}'`, backgroundSize: "cover" }
        }
      >
        <main
          className="mx-auto max-w-7xl px-4 sm:px-6 md:mt-0 lg:px-8 flex flex-col md:flex-row items-center justify-center md:justify-between h-screen"
          id="/"
        >
          <div className="sm:text-center lg:text-left">
            <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
              <motion.span
                className={darkMode ? "block text-black" : "block text-white"}
              >
                Hi, I am Raju
              </motion.span>
              <span className="block text-blue-500 z-0 lg:inline">
                <TypeAnimation
                  sequence={[
                    "Front End Developer",
                    1000,
                    "Full Stack Developer",
                    1000,
                    "Mobile Developer",
                    1000,
                  ]}
                  wrapper="span"
                  speed={50}
                  repeat={Infinity}
                />
              </span>
            </h1>
            <p
              className={
                darkMode
                  ? "mt-3 text-base text-black sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0"
                  : "mt-3 text-base text-white sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0"
              }
            >
              {Constant.shortIntro}
            </p>
            <div className="flex md:justify-start ">
              {Constant.contactLinks.map((el,index) => resume && el.name === "Youtube" ? null :(
                <a key={index}
                  href={el.link}
                  rel="noreferrer" 
                  target="_blank"
                  className="mr-5 cursor-pointer mt-8 hover:scale-125"
                >
                  <img alt="" src={el.url} />
                  {/* <p className="text-md mt-2 hover:hidden">{el.name}</p> */}
                </a>
              ))}
            </div>
           {resume && <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
              <div className="mt-3 sm:mt-0 cursor-pointer w-1/2">
                <a target="_blank" rel="noreferrer" 
                  href={resume} 
                  className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-500 hover:bg-blue-200 md:py-4 md:text-lg md:px-10">
                  Resume
                </a>
              </div>
            </div>}
          </div>
          <motion.img
            initial="hidden"
            whileInView={"visible"}
            variants={{
              visible: {
                y: 0,
                opacity: 1,
                transition: {
                  type: "spring",
                },
              },
              hidden: { opacity: 1, y: 80 },
            }}
            src={Constant.heroBg}
            alt="hero-bg"
            className="w-full sm:block hidden"
            style={{ width: '40%' }} 
          />
        </main>
      </div>
    </>
  );
};

export default Home;
